// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { isVariantEnabled, makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForKPITableHeaderCell = makeThemedStyles(
  'KPITable.KPITableHeader.KPITableHeaderCell',
  () => ({
    KPITableHeaderCell: {
      fontWeight: 'bold',
      display: 'table-cell',
      padding: '0.7em'
    },

    center: {
      textAlign: 'center'
    }
  })
);

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const KPITableHeaderCell: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForKPITableHeaderCell();

  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.KPITableHeaderCell, {
        [styles.center]: isVariantEnabled(props, 'center')
      })}
    >
      {props?.children}
    </div>
  );
};
export default KPITableHeaderCell;
